import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function AdminLogin() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/admin/login`, { email, password });
      localStorage.setItem('hrv_admin_token', res.data.token);
      localStorage.setItem('hrv_admin_info', JSON.stringify(res.data.admin));
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '16px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>🛡️</div>
          <h1 style={{ color: 'white', fontSize: '1.8rem', fontWeight: '700', margin: 0 }}>HRV Admin</h1>
          <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: '8px 0 0' }}>Restricted access — administrators only</p>
        </div>

        <div style={{
          background: '#1e293b', borderRadius: '16px', padding: '36px',
          border: '1px solid #334155', boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
        }}>
          <h2 style={{ color: 'white', fontSize: '1.2rem', fontWeight: '600', margin: '0 0 24px' }}>Sign in to Admin Panel</h2>

          {error && (
            <div style={{ background: '#450a0a', border: '1px solid #991b1b', color: '#fca5a5', borderRadius: '8px', padding: '12px', marginBottom: '20px', fontSize: '0.875rem' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', fontWeight: '500', marginBottom: '8px' }}>
                Admin Email
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)} required
                style={{
                  width: '100%', padding: '12px 14px', background: '#0f172a',
                  border: '1px solid #334155', borderRadius: '8px', color: 'white',
                  fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box',
                }}
                placeholder="admin@example.com"
              />
            </div>

            <div style={{ marginBottom: '28px' }}>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: '0.85rem', fontWeight: '500', marginBottom: '8px' }}>
                Password
              </label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)} required
                style={{
                  width: '100%', padding: '12px 14px', background: '#0f172a',
                  border: '1px solid #334155', borderRadius: '8px', color: 'white',
                  fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box',
                }}
                placeholder="••••••••"
              />
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '13px', background: loading ? '#334155' : '#6366f1',
              color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem',
              fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: '#475569', fontSize: '0.8rem', marginTop: '20px' }}>
          ← <a href="/login" style={{ color: '#6366f1', textDecoration: 'none' }}>Back to user login</a>
        </p>
      </div>
    </div>
  );
}
